export function scrollToSectionWithOffset(id: string) {
    const el = document.getElementById(id);
    if (!el) return;

    const header = document.querySelector(".navbar");
    const headerHeight = header?.getBoundingClientRect().height || 62;

    const y =
      el.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  export function waitForImagesToLoadThenScroll(sectionId: string, containerId: string, timeoutMs: number, maxRetries: number) {
      const container = document.getElementById(containerId);
  
      if (!container) {
        setTimeout(() => {
          if (maxRetries <= 0) {
            scrollWithAnimationFrame();
          } else {
            waitForImagesToLoadThenScroll(sectionId, containerId, timeoutMs, maxRetries - 1);
          }
        }, 150);
        return;
      }
      const images = Array.from(container.querySelectorAll("img")) as HTMLImageElement[];
  
      const notLoaded = images.filter(i => !i.complete);
  
      const scrollWithAnimationFrame = () => {
        requestAnimationFrame(() => scrollToSectionWithOffset(sectionId));
      };
  
      if (notLoaded.length === 0) {
        scrollWithAnimationFrame();
        return;
      }
  
      let loaded = 0;
      let finishedLoading = false;
  
      const checkLoaded = () => {
        loaded++;
        if (loaded === notLoaded.length && !finishedLoading) {
          finishedLoading = true;
          scrollWithAnimationFrame();
          return;
        }
      }
  
      notLoaded.forEach(img => {
        img.addEventListener("load", checkLoaded, { once: true });
        img.addEventListener("error", checkLoaded, { once: true });
      });
  
      setTimeout(() => {
        if (!finishedLoading) {
          scrollWithAnimationFrame();
        }
      }, timeoutMs);
    };